import { render, staticRenderFns } from "./ExtraData.vue?vue&type=template&id=130f6ef4&scoped=true"
import script from "./ExtraData.vue?vue&type=script&lang=js"
export * from "./ExtraData.vue?vue&type=script&lang=js"
import style0 from "./ExtraData.vue?vue&type=style&index=0&id=130f6ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f6ef4",
  null
  
)

export default component.exports